import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const checkBoxLabelCss = (isChecked: boolean) => ({
  alignItems: "flex-start",
  maxWidth: "calc(100vw - 72px)",
  padding: "0",
  color: isChecked ? ui.neutral[700] : ui.neutral[500],
  outlineOffset: "4px",
});
